import { render, staticRenderFns } from "./GroupPointLayout.vue?vue&type=template&id=2161cd84&scoped=true&"
import script from "./GroupPointLayout.vue?vue&type=script&lang=js&"
export * from "./GroupPointLayout.vue?vue&type=script&lang=js&"
import style0 from "./GroupPointLayout.vue?vue&type=style&index=0&id=2161cd84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2161cd84",
  null
  
)

export default component.exports